export const listItems = [
    [
        <i key={1} className="appkiticon icon-person-outline icon" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>User</span>,
    ],
    [
        <i key={1} className="appkiticon icon-management-outline icon" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: 'white', fontSize: '0.7rem' }}>Tenant</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline icon" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Intake</span>,
    ],
];

export const ADD_LATER = '';
